import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from "react";
import { isAutocompleteSelectSubmit, useCioAutocomplete } from "@constructor-io/constructorio-ui-autocomplete";
import { emitSearchAction, emitSearchboxImpression, SOURCE_TYPE_ENHANCED_SEARCH_BOX } from "@catchoftheday/analytics";
import { Label } from "@catchoftheday/cg-components";
import { encodeSearchTerm } from "@catchoftheday/utilities";
import { CONSTRUCTOR_API_KEY, SEARCH_INPUT_PLACEHOLDER, SEARCH_SUGGESTION_INDEX_NAME } from "../../consts";
import { DropdownOverlay } from "../../layouts/SearchBar/DropdownOverlay";
import { SearchBarWrapper, SearchBoxZone, Spacer, SuggestedProductsZone, SuggestedSearchTermsZone } from "../../layouts/SearchBar/SearchBarLayouts";
import { SearchDropdownZone } from "../../layouts/SearchBar/SearchDropdownZone";
import { CloseButton } from "../../pure/SearchBar/CloseButton/CloseButton";
import { SearchButton } from "../../pure/SearchBar/SearchButton/SearchButton";
import { SearchForm } from "../../pure/SearchBar/SearchForm/SearchForm";
import { SearchInput } from "../../pure/SearchBar/SearchInput/SearchInput";
import { SearchSuggestions } from "../../pure/SearchBar/SearchSuggestions/SearchSuggestions";
import { jsx as ___EmotionJSX } from "@emotion/react";
var args = {
  apiKey: CONSTRUCTOR_API_KEY,
  placeholder: SEARCH_INPUT_PLACEHOLDER,
  sections: [{
    indexSectionName: SEARCH_SUGGESTION_INDEX_NAME,
    numResults: 12
  }]
};
export var SearchBarContainer = function SearchBarContainer() {
  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(),
      autocompleteItems = _useState2[0],
      setAutocompleteItems = _useState2[1];

  function navigateToSearchPage(_x, _x2, _x3) {
    return _navigateToSearchPage.apply(this, arguments);
  }

  function _navigateToSearchPage() {
    _navigateToSearchPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(term, inputTerm, sourceType) {
      var encodedSearchTerm, query, params, url;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!term || term.length == 1)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              encodedSearchTerm = encodeSearchTerm(term);
              query = "/search?query=".concat(encodedSearchTerm);
              params = "&search_src=topbar&ac=0;\n    }".concat(sourceType ? "&st=".concat(sourceType) : "");
              url = "".concat(query).concat(encodeURI(params));
              emitSearchAction({
                user_text: inputTerm,
                is_typehead: term !== inputTerm,
                final_text: term,
                is_special_search: false,
                special_search_details: undefined
              });
              window.location.assign(url);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _navigateToSearchPage.apply(this, arguments);
  }

  var _useCioAutocomplete = useCioAutocomplete(_objectSpread(_objectSpread({}, args), {}, {
    onFocus: function onFocus() {
      setIsOpen(true);
      emitSearchboxImpression();
    },
    onSubmit: function onSubmit(event) {
      if (isAutocompleteSelectSubmit(event)) {
        navigateToSearchPage(event.item.value, event.originalQuery, SOURCE_TYPE_ENHANCED_SEARCH_BOX);
      }
    }
  })),
      sections = _useCioAutocomplete.sections,
      getFormProps = _useCioAutocomplete.getFormProps,
      getInputProps = _useCioAutocomplete.getInputProps,
      getMenuProps = _useCioAutocomplete.getMenuProps,
      getItemProps = _useCioAutocomplete.getItemProps,
      getSectionProps = _useCioAutocomplete.getSectionProps,
      getLabelProps = _useCioAutocomplete.getLabelProps;

  var inputProps = getInputProps();

  var toggleDropdownVisibility = function toggleDropdownVisibility() {
    setIsOpen(!isOpen);
  };

  useEffect(function () {
    sections.map(function (section) {
      if ("indexSectionName" in section && section.indexSectionName === SEARCH_SUGGESTION_INDEX_NAME) {
        setAutocompleteItems(section);
      }
    });
  }, [sections]);
  return ___EmotionJSX(SearchBarWrapper, null, isOpen && ___EmotionJSX(DropdownOverlay, {
    onClick: toggleDropdownVisibility
  }), ___EmotionJSX(SearchBoxZone, {
    isOpen: isOpen
  }, ___EmotionJSX(SearchForm, getFormProps(), ___EmotionJSX(Label, _extends({
    htmlFor: inputProps.id
  }, getLabelProps()), ___EmotionJSX(SearchInput, _extends({
    isOpen: isOpen
  }, inputProps))), ___EmotionJSX(SearchButton, {
    isOpen: isOpen
  })), ___EmotionJSX(SearchDropdownZone, {
    isOpen: isOpen
  }, ___EmotionJSX(CloseButton, {
    onClick: toggleDropdownVisibility
  }), ___EmotionJSX(SuggestedSearchTermsZone, getMenuProps(), autocompleteItems && ___EmotionJSX(SearchSuggestions, _extends({
    data: autocompleteItems.data,
    getItemProps: getItemProps,
    title: autocompleteItems.indexSectionName || SEARCH_SUGGESTION_INDEX_NAME,
    hasResults: sections.length > 0
  }, getSectionProps(autocompleteItems)))), ___EmotionJSX(SuggestedProductsZone, null))), ___EmotionJSX(Spacer, null));
};